import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import * as _ from 'lodash';

import { AuthDataInterface } from '../models/view-models/account-models/auth-data.interface';
import { AppConstants } from '../../app.constants';

@Injectable()
export class RoleGuard  {

    constructor(public router: Router) { }
    canActivate(route: ActivatedRouteSnapshot): boolean {

        // this will be passed from the route config
        // on the data property
        const expectedRoless: string[] = route.data.expectedRoles;
        const possibleRole: string = route.data.possibleRole;

        const authData: AuthDataInterface = JSON.parse(localStorage.getItem(AppConstants.AUTH_DATA_NAME));
        const userRoles: string[] = authData.roles.split(',');
        if (!(authData && authData.roles &&
            (_.some(expectedRoless, (expectedRole: string) => userRoles.includes(expectedRole))
                || (userRoles.length === 1 && userRoles.includes(possibleRole))))) {
            this.router.navigate(['Forbidden']);
            return false;
        }

        return true;
    }
}
